import { getTrayectoById, getTrayectoRowIndex } from "./curriculumMalla";

/**
 * Builds per-semester cell placement for the curriculum matrix (5 trayecto rows).
 * @returns {Record<number, { semestre: number, rows: Array<{ blocked: boolean, cell: object|null }> }>}
 */
export function buildSemesterColumns(materias, meta) {
  const rowCount = meta.trayectos.length;
  const bySem = materias.reduce((acc, m) => {
    if (!acc[m.Semestre]) acc[m.Semestre] = [];
    acc[m.Semestre].push(m);
    return acc;
  }, {});

  const columns = {};

  meta.semestres.forEach((semestre) => {
    const rows = Array.from({ length: rowCount }, () => ({
      blocked: false,
      cell: null,
    }));

    const semMaterias = bySem[semestre] || [];
    const spanning = semMaterias
      .filter((m) => m.SpanTrayectos > 1)
      .sort((a, b) => {
        const rowA = getTrayectoRowIndex(meta, a.Trayecto);
        const rowB = getTrayectoRowIndex(meta, b.Trayecto);
        return rowA - rowB || a.Orden - b.Orden;
      });

    const single = semMaterias
      .filter((m) => m.SpanTrayectos <= 1)
      .sort((a, b) => {
        const rowA = getTrayectoRowIndex(meta, a.Trayecto);
        const rowB = getTrayectoRowIndex(meta, b.Trayecto);
        return rowA - rowB || a.Orden - b.Orden;
      });

    spanning.forEach((materia) => {
      const startRow = getTrayectoRowIndex(meta, materia.Trayecto);
      if (startRow < 0) return;
      const span = materia.SpanTrayectos;
      let canPlace = true;
      for (let i = 0; i < span; i++) {
        if (startRow + i >= rowCount || rows[startRow + i].blocked) {
          canPlace = false;
          break;
        }
      }
      if (!canPlace) return;

      const trayecto = getTrayectoById(meta, materia.Trayecto);
      rows[startRow].cell = {
        materias: [materia],
        rowSpan: span,
        trayecto,
      };
      for (let i = 1; i < span; i++) {
        rows[startRow + i].blocked = true;
      }
    });

    single.forEach((materia) => {
      const startRow = getTrayectoRowIndex(meta, materia.Trayecto);
      if (startRow < 0 || rows[startRow].blocked) return;

      const trayecto = getTrayectoById(meta, materia.Trayecto);
      const existing = rows[startRow].cell;

      if (existing && existing.rowSpan === 1) {
        existing.materias.push(materia);
        existing.materias.sort((a, b) => a.Orden - b.Orden);
        return;
      }

      if (!existing) {
        rows[startRow].cell = {
          materias: [materia],
          rowSpan: 1,
          trayecto,
        };
      }
    });

    columns[semestre] = { semestre, rows };
  });

  return columns;
}
